const InstallationMetricSnapshot = ({
  icon: Icon,
  iconVariant = "default",
  eyebrow,
  value,
  valueLoading = false,
  subtitle,
  hint,
  tone = "neutral",
}) => {
  return (
    <section
      className={`installation-metric-snapshot installation-metric-snapshot-${tone}`}
    >
      <div className="installation-metric-snapshot-main">
        <span
          className={`installation-metric-snapshot-icon installation-metric-snapshot-icon-${iconVariant}`}
          aria-hidden
        >
          <Icon />
        </span>
        <div className="installation-metric-snapshot-body">
          <span className="installation-metric-snapshot-eyebrow">
            {eyebrow}
          </span>
          <p className="installation-metric-snapshot-value">
            {valueLoading ? "…" : value}
          </p>
          {subtitle && (
            <p className="installation-metric-snapshot-subtitle">{subtitle}</p>
          )}
        </div>
      </div>
      {hint && <p className="installation-metric-snapshot-hint">{hint}</p>}
    </section>
  );
};

export default InstallationMetricSnapshot;
